import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot} from '@angular/router';
import { AuthService } from '@core/services/authentication/auth.service';

@Injectable()
export class BusinessUnitGuard implements CanActivate {

  readonly permiso: any = {};

  constructor(
    private readonly router: Router,
    private readonly _authService: AuthService,
  ) {
  }
  canActivate(_route: ActivatedRouteSnapshot): boolean{
    if (this._authService.isSectorSelect()) {
        this.router.navigate(['/tienda']);
      return true;
    } else{
      // this.router.navigate(['/unidades-de-negocio']);
      return true;
    }
  }

}
